import { fetchEpic} from "./epics"
import { combineEpics } from "redux-observable"

export const combinedEpics = combineEpics(
    fetchEpic
)


// WEBPACK FOOTER //
// ./src/state/project/epics/index.ts